'use strict';

import EnhancedSeo from './enhancedSeo';
import OrdersPagination from './myaccount/ordersPagination';
import PaymentInstruments from './myaccount/paymentinstruments';
import { appendToUrl } from './services/utils';
import { updateZipCodePattern } from './util/postalCodePattern';
import { initStateBasedOnCountry, makeStatesAccortingToCountry } from './util/statesAccordingCountry';

var formHelpers = require('./util/formErrors');

class myAccount {
  constructor() {
    this.registerForm = $('.registration-form');
    this.addressForm = $('.address-form');
  }

  run() {
    $(document).ready(() => {
      this.register();
      this.editAddress();
      this.dashboard();
      this.resetPassword();
      this.copyValueToModal();
      // this.checkProfiling();
      OrdersPagination.ordersPaginationAjax();
      PaymentInstruments.removePayment();
      EnhancedSeo.clickOnChangeEmail(['form.edit-profile-form', '.change-email']);
      EnhancedSeo.clickOnChangePassword(['form.edit-profile-form', '.change-password-button']);
    });

    const googleRecaptchaClientSide = document.querySelector('input[name="googleRecaptchaClientSide"]');
    if (googleRecaptchaClientSide) {
      grecaptcha.ready(function () {
        grecaptcha.execute(googleRecaptchaClientSide.value, { action: 'registration_form' }).then(function (token) {
          $('.registration-form').prepend(`<input type="hidden" name="googleRecaptchaToken" value="${token}">`);
          $('.registration-form').prepend('<input type="hidden" name="googleRecaptchaAction" value="registration_form">');
        });
        setInterval(function () {
          grecaptcha.execute(googleRecaptchaClientSide.value, { action: 'registration_form' }).then(function (token) {
            $('input[name=googleRecaptchaToken]').val(token);
          });
        }, 90000); // tokens gets marked as expired after 2 mins https://github.com/google/recaptcha/issues/302
      });
    }
  }

  register() {
    var form = this.registerForm;
    this.registerForm.ready(function () {
      if (form.length) {
        updateZipCodePattern(form);
        initStateBasedOnCountry(form, null, 'stateLabel', 'countryLabel');
      }
    });

    this.registerForm.find('label#countryLabel select').change(function (e) {
      updateZipCodePattern(form);
      makeStatesAccortingToCountry(e, null, 'stateLabel', 'countryLabel');
    });

    $(window).on('beforeunload', (e) => {
      window.localStorage.removeItem('registeremail');
    });

    this.registerForm.find('input[name$=_email]').change(function (e) {
      var $self = $(e.currentTarget);
      var emailNL = $self.val();
      if (emailNL.length > 0) {
        if (window.localStorage.getItem('registeremail') != emailNL) {
          window.localStorage.setItem('registeremail', emailNL);
          $('#email-signup').removeClass('nlchecked');
        }
      }
      if (emailNL.length > 0 && !$('#email-signup').hasClass('nlchecked')) {
        var urlNL = $self.attr('data-checknl');
        $.ajax({
          url: urlNL,
          type: 'post',
          dataType: 'json',
          data: {
            registeremail: emailNL
          },
          success: (data) => {
            $('#email-signup').addClass('nlchecked');
            if (data.success) {
              $('#email-signup').prop('checked', true);
            } else {
              $('#email-signup').prop('checked', false);
            }
            $('#email-signup').trigger('change');
          },
          error: (err) => {
            window.localStorage.removeItem('registeremail');
          }
        });
      }
    });

    this.registerForm.submit(function (e) {
      var form = $(this);
      e.preventDefault();

      var button = form.find('.button');
      $(button).attr('disabled', true);

      var url = form.attr('action');

      formHelpers.clearPreviousErrors(form);

      $.ajax({
        url: url,
        type: 'post',
        dataType: 'json',
        data: form.serialize(),
        success: function (data) {
          var errors = 0;
          for (var key in data.errorFields) {
            if (data.errorFields.hasOwnProperty(key)) errors++;
          }

          if (errors > 0 && data.redirectUrl) {
            window.localStorage.removeItem('registeremail');
            window.location.href = data.redirectUrl;
          } else if (errors > 0) {
            // reload recaptcha
            const googleRecaptchaClientSide = document.querySelector('input[name="googleRecaptchaClientSide"]');
            if (googleRecaptchaClientSide) {
              console.info('reloading captcha');
              grecaptcha.execute(googleRecaptchaClientSide.value, { action: 'registration_form' }).then(function (token) {
                $('input[name=googleRecaptchaToken]').val(token);
              });
            }

            $(button).attr('disabled', false);
            formHelpers.loadFormErrors(form, data.errorFields);

            var markedinvalid = $('.is-invalid-input');
            if (markedinvalid.length > 0) {
              $([document.documentElement, document.body]).animate({
                scrollTop: markedinvalid.offset().top - 100
              }, 1000);
            }
          }

          if (errors === 0 && data.redirectUrl) {
            window.localStorage.removeItem('registeremail');
            EnhancedSeo.registerOkEvent(data.profiling, data.newsletter);
            $.get(data.logOutUrl);
            window.location.href = data.redirectUrl;
          }
        },
        error: function (err) {
          if (err.responseJSON.redirectUrl) {
            window.localStorage.removeItem('registeremail');
            window.location.href = err.responseJSON.redirectUrl;
          } else {
            var button = form.find('.button');
            $(button).attr('disabled', false);
          }
        }
      });
      return false;
    });
  }

  editAddress() {
    var form = this.addressForm;
    this.addressForm.ready(function () {
      if (form.length) {
        updateZipCodePattern(form);
        initStateBasedOnCountry(form, null, 'stateLabel', 'countryLabel');
      }
    });

    this.addressForm.find('label#countryLabel select').change(function (e) {
      updateZipCodePattern(form);
      makeStatesAccortingToCountry(e, null, 'stateLabel', 'countryLabel');
    });
  }

  dashboard() {
    $('form.edit-profile-form').ready(function () {
      if ($('form.edit-profile-form').length) {
        updateZipCodePattern($('form.edit-profile-form'));
        initStateBasedOnCountry($('form.edit-profile-form'), null, 'stateLabel', 'countryLabel');
      }
    });

    $('.row-basket-items').on('click', '.remove-product', (e) => {
      e.preventDefault();
      const self = $(e.currentTarget);
      const action = self.attr('href');
      let pid = self.attr('data-id');
      let uuid = self.attr('data-uuid');

      this.removeProduct(action, pid, uuid);
    });
  }

  removeProduct(actionUrl, productID, uuid) {
    const url = appendToUrl(actionUrl, {
      pid: productID,
      uuid: uuid
    });

    $.ajax({
      url: url,
      type: 'get',
      dataType: 'json',
      success: (data) => {
        document.location.reload();
      },
      error: (err) => {
        if (err.responseJSON.redirectUrl) {
          window.location.href = err.responseJSON.redirectUrl;
        }
      }
    });
  }

  resetPassword() {
    if (typeof window.sessionStorage !== 'undefined') {
      if (window.sessionStorage.forgotPasswordMail) {
        $('#reset-password-form').find('[name="loginEmail"]').val(window.sessionStorage.forgotPasswordMail);
        delete window.sessionStorage.forgotPasswordMail;
      }
    }

    $('#reset-password-form').on('submit', (e) => {
      e.preventDefault();

      const $form = $(e.currentTarget);
      const $modal = $('#forgot-password-modal');
      const url = $form.attr('action');

      $modal.addClass('loading');

      $.ajax({
        url: url,
        type: 'post',
        dataType: 'json',
        data: $form.serialize(),
        success: (data) => {
          if (!data.success) {
            $form.parsley().validate();
            if (Object.hasOwnProperty.call(data, 'fields')) {
              formHelpers.resetErrorList($form, data.fields);
              formHelpers.loadFormErrors($form, data.fields);
            }
          } else if (Object.prototype.hasOwnProperty.call(data, 'redirectUrl')) {
            if (data.redirectUrl) {
              window.location.href = data.redirectUrl;
            }
          } else {
            $modal.removeClass('loading');
            $('.request-password-body').empty().append(`<p class="description text-center">${data.receivedMsgBody}</p>`);
          }
        },
        error: () => {
          console.log('error in process request');
        }
      });
    });
  }

  copyValueToModal() {
    $('.login-form-render').on('click', '.underline', () => {
      let emailVal = $('#login-form-email').val();
      $('#reset-password-email').val(emailVal);
    });
  }

  checkProfiling() {
    const $profiling = $('#profiling');
    const $emailSignUp = $('#email-signup');

    if ($emailSignUp.is(':checked')) {
      $profiling.removeAttr('disabled');
    } else {
      $profiling.attr('checked', false);
    }

    $emailSignUp.on('change', (e) => {
      const self = $(e.currentTarget);

      if (self.is(':checked')) {
        $profiling.removeAttr('disabled');
      } else {
        $profiling.attr('disabled', 'disabled');

        if ($profiling.is(':checked')) {
          $profiling.prop('checked', false);
        }
      }
    });
  }
}

const MyAccount = new myAccount();
MyAccount.run();



// WEBPACK FOOTER //
// ./assets/scripts/myaccount.js